import type { ReactNode } from 'react'

interface MobileStudioLayoutProps {
  sidebar: ReactNode
  preview: ReactNode
}

/**
 * Split-panel layout for the Mobile Studio Builder.
 * Desktop (>= 768px): sidebar 360px left + preview fills right
 * Mobile (< 768px): preview on top (55%), controls on bottom (45%)
 */
export function MobileStudioLayout({ sidebar, preview }: MobileStudioLayoutProps) {
  return (
    <div className="flex h-[calc(100dvh-4rem)] flex-col md:flex-row">
      {/* Preview — shown first on mobile (top), second on desktop (right) */}
      <div className="order-first flex flex-1 items-center justify-center overflow-hidden bg-gray-50 md:order-last">
        {preview}
      </div>

      {/* Sidebar — shown second on mobile (bottom), first on desktop (left) */}
      <div className="order-last h-[45%] shrink-0 overflow-y-auto border-t border-gray-200 bg-white md:order-first md:h-full md:w-[360px] md:border-r md:border-t-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {sidebar}
      </div>

      {/* Mobile: preview takes 55% via flex-1, sidebar takes 45% via h-[45%] */}
    </div>
  )
}
